var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 23.25,
    height: 23.25,
    rx: 11.625,
    fill: "#F6F6F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 23.25,
    height: 23.25,
    rx: 11.625,
    stroke: "white",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1018 8.89045C9.8913 9.31688 9.48463 9.61258 9.01408 9.68136L5.49326 10.196C5.19681 10.2393 5.07865 10.6037 5.29328 10.8128L7.83949 13.2928C8.18063 13.625 8.33633 14.1039 8.25583 14.5733L7.65499 18.0765C7.60433 18.3719 7.91439 18.5971 8.17965 18.4576L11.3269 16.8025C11.7483 16.5809 12.2518 16.5809 12.6733 16.8025L15.8205 18.4576C16.0858 18.5971 16.3959 18.3719 16.3452 18.0765L15.7444 14.5733C15.6639 14.1039 15.8196 13.625 16.1607 13.2928L18.7069 10.8128C18.9215 10.6037 18.8034 10.2393 18.5069 10.196L14.9861 9.68136C14.5156 9.61258 14.1089 9.31688 13.8984 8.89045L12.3243 5.70153C12.1917 5.43282 11.8085 5.43282 11.6759 5.70153L10.1018 8.89045Z",
    fill: "#188DED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteOn);
export default __webpack_public_path__ + "static/media/favorite_on.4dc69e745faadddf9583984cbfd7aff4.svg";
export { ForwardRef as ReactComponent };